import { makeAutoObservable } from "mobx";

export type SnackType = "info" | "success" | "warning" | "error";

export class SnackStore {
  private static instance: SnackStore;

  public isOpen = false;
  public message = "";
  public severity: SnackType = "info";

  private constructor() {
    makeAutoObservable(this);
  }

  public static getInstance(): SnackStore {
    if (!SnackStore.instance) {
      SnackStore.instance = new SnackStore(); // Create instance if it doesn't exist
    }
    return SnackStore.instance; // Return the existing instance
  }

  public showError(message: string) {
    this.message = message;
    this.severity = "error";
    this.isOpen = true;
  }

  public showSuccess(message: string) {
    this.message = message;
    this.severity = "success";
    this.isOpen = true;
  }

  public clear() {
    this.message = "";
    this.isOpen = false;
  }
}
